import MembershipCancellationSurveyScreen from '@/screens/join-premium/MembershipCancellationSurvey'

export default function () {
  return <MembershipCancellationSurveyScreen />
}
